import { Dispatch } from 'redux';

import { updateMaintenance } from '../ducks/platformData';
import { logout } from '../ducks/auth';
import { LogoutTypes, WSMessageTypes } from './constants';

let ws: WebSocket | undefined;

export const connectWebSocket = (
  id: string,
  token: string,
  dispatch: Dispatch,
  isAdmin: boolean,
) => {
  if (!ws || ws.readyState === WebSocket.CLOSED) {
    try {
      ws = new WebSocket(`wss://${window.location.host}/ws`);
      ws.onopen = () => ws?.send(JSON.stringify({ id, token }));
      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          switch (data.type) {
            case WSMessageTypes.Maintenance:
              dispatch(updateMaintenance(data.maintenance) as any);
              break;
            case WSMessageTypes.Logout:
              if (!isAdmin) {
                dispatch(logout(LogoutTypes.Maintenance) as any);
              }
              break;
            default:
              break;
          }
        } catch (e) {
          console.error(e);
        }
      };
    } catch (e) {
      console.error(e);
    }
  }
};

export const closeWebSocket = () => {
  if (ws) {
    try {
      ws.close();
    } catch (e) {
      console.error(e);
    }
  }
};

export default connectWebSocket;
